<template>
  <div id="app">
    <TopNavigationBar />
    <b-container v-if="maintenance" class="d-flex flex-column justify-content-center align-items-center" >
      <br><br>
      <img :src="require('@/assets/images/InfoAM.png')" class="logo">
      <br>
      <h1>AndyMark Info</h1>
      <h2>DOWN FOR MAINTENANCE</h2>
    </b-container>
    <b-alert v-else-if="!canAccess" show variant=warning>
      Sorry, you don't have access to this page... Try logging in?<br/><br/>
      If you are logged in, and you believe you should have access to this page, ask IT for access!
    </b-alert>
    <router-view v-else />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TopNavigationBar from './components/TopNavigationBar';
import axios from 'axios';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  name: 'App',
  mounted() {
    axios.get(`${BASE_API}/../maintenance`).then((r) => { this.maintenance = r.data })
    this.getLoggedInUser();
    this.getSettings();
  },
  data() {
    return {
      maintenance: null,
      infoAccess: false,
      returnsPages: [ "RMA HC" ],
      partInfoPages: [ "Part Info", "Part Evaluator", "PO Report", "Product Pricing Sums", "Sales Summary", "Pricing Margin Report" ],
      opsInfoPages: [ "Tracking Number Entry" ],
      accountingInfoPages: [ ],
      itPages: [ "Locked Orders", "Query Passthrough" ],
      accountingPages: [ "Inventory Costing Report" ]
    }
  },
  components: {
    TopNavigationBar,
  },
  created() {
    axios.interceptors.response.use(undefined, (err) => {
      return new Promise( (resolve, reject) => {
        if (err.status == 401 && err.config && !err.config.__isRetryRequest) {
          router.push('/')
        }
        throw err
      })
    })
    axios.get(`${BASE_API}/auth`).then(r => {
      this.infoAccess = !!r.data
    })
  },
  computed: {
    canAccess() {
      return this.infoAccess &&
        this.rolesMatch(this.returnsPages, 'returns-info-access') &&
        this.rolesMatch(this.partInfoPages, 'part-info-access') &&
        this.rolesMatch(this.opsInfoPages, 'ops-access') &&
        this.rolesMatch(this.accountingInfoPages, 'accounting-access') &&
        this.rolesMatch(this.itPages, 'it-staff')
    },
  },
  methods: {
    ...mapActions({
      getLoggedInUser: 'getLoggedInUser',
      getSettings: 'getSettings',
    }),
    rolesMatch(arr, role) {
      return !arr.includes(this.$route.name) || this.$store.getters.canAccess(role)
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue